import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IEventState } from '@shared/types/event';

export const selectEventsFeature = createFeatureSelector<Readonly<IEventState>>('events');

export const selectIframePostMessageResult = createSelector(selectEventsFeature, (state) => ({
    iframePostMessageResult: state.iframePostMessageResult,
}));

export const selectEventState = createSelector(selectEventsFeature, (state) => state);

export const selectEventsState = createSelector(selectEventsFeature, (state) => ({
    events: state.events,
}));

export const selectSelectedEventsState = createSelector(selectEventsFeature, (state) => state.selectedEvents);

export const selectActiveEventAndEvents = createSelector(selectEventsFeature, (state) => ({
    selectedEvent: state.selectedEvent,
    selectedEvents: state.selectedEvents,
    selectedEventsReportId: state.selectedEventsReportId,
}));
